module.exports = __webpack_public_path__ + "static/media/calefont15.6a04cc5e.png";